<script lang="ts">
  import { onMount } from "svelte";
  import DocumentExtract from "../components/extract/DocumentExtract.svelte";

  let documentId: string = "";

  onMount(() => {
    const queryParams = new URLSearchParams(window.location.search);
    documentId = queryParams.get("id") || "";
  });
</script>

<div class="standalone-container extract-document-container">
  {#if documentId}
    <DocumentExtract {documentId} documentTitle="Journal of Clinical Oncology" showExternalLink={false} />
  {:else}
    <div class="error-message">
      <p>No document ID provided</p>
    </div>
  {/if}
</div>

<style>
  .error-message {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    color: var(--text-primary);
  }
</style>
